import e from "react";
import { D as o } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as d } from "./index-BB-Wk85r.es.js";
import { g as s } from "./utils-Ci4OZEP4.es.js";
import './Badge.css';const n = "Badge-module__badge___wN1B2", m = {
  badge: n
}, B = ({
  children: r,
  color: a
}) => {
  const t = s(a, "ListCard.Badge");
  return /* @__PURE__ */ e.createElement("span", { className: m.badge, style: { backgroundColor: a } }, /* @__PURE__ */ e.createElement(o, { darkMode: t }, /* @__PURE__ */ e.createElement(d.Body3, { darkBg: t, responsive: !0 }, /* @__PURE__ */ e.createElement("b", null, r))));
};
export {
  B
};
